import mitt from "mitt"

export type Events = {
  "common:resourcePicker:show": any
  "common:resourcePicker:hide": any
  "common:modal:show": any
  "common:modal:hide": any
}
const emitter = mitt<Events>()
export default emitter
